import { useEffect, useState } from "react";
import type { ReactNode } from "react";
import { getMe, logoutApi } from "../api";
import type { AuthUser } from "../types/auth";
import { AuthContext } from "../hooks/useAuth";

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<AuthUser | null>(null);
  // Only "loading" when there's a token to resolve into a session.
  const [loading, setLoading] = useState(() => !!localStorage.getItem("access_token"));

  useEffect(() => {
    if (!localStorage.getItem("access_token")) return;
    getMe()
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = (accessToken: string, refreshToken?: string) => {
    localStorage.setItem("access_token", accessToken);
    if (refreshToken) localStorage.setItem("refresh_token", refreshToken);
    return getMe().then((res) => setUser(res.data));
  };

  const logout = async () => {
    const rt = localStorage.getItem("refresh_token");
    if (rt) {
      try { await logoutApi(rt); } catch { /* best-effort */ }
    }
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setUser(null);
  };

  const refreshUser = () => getMe().then((res) => setUser(res.data));

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}
